  <!-- MIGAS DE PAN Y TÍTULO -->
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="bg-second-migas">
    <div class="container mt-cab-fixed">
      <div class="pre-content">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Poseedores</li>
            <li class="breadcrumb-item">Búsqueda de Poseedores</li>
          </ol>
        </nav>
        <div class="content-title">
          <h2 class="title-pag">Búsqueda de Poseedores</h2>
        </div>
      </div>
    </div>
  </div>
  <!-- FIN MIGAS DE PAN Y TÍTULO -->
  <!-- CONTENIDO -->

  <div class="container-form">
    <!-- Barra de filtros aplicados -->
    <div class="filtros-bar">
      <div class="filtros-aplicados">
        <span class="filtros-label">Filtros aplicados</span>
        <span *ngFor="let filtro of filtrosAplicados" class="filtro-chip">
          {{filtro.label}}
          <button type="button" class="chip-remove" (click)="quitarFiltro(filtro)">×</button>
        </span>
      </div>
      <button type="button" class="btn-toggle-filtros" (click)="toggleFiltros()">
        <mat-icon>tune</mat-icon>
        {{ mostrarFiltros ? 'Ocultar Filtros' : 'Ver Filtros' }}
      </button>
    </div>
    <!-- Formulario de búsqueda -->
    <form *ngIf="mostrarFiltros" class="container form-search py-3" [formGroup]="searchForm">
      <div class="d-flex flex-wrap" style="gap: 1rem;">
        <!-- Campo 1 -->
        <div style="flex: 1 1 80px; max-width: 150px;">
          <label for="idPoseedor">ID. Poseedor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="idPoseedor" id="idPoseedor" placeholder="ID. Poseedor" type="text" (keydown)="onlyNumberKey($event)">
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 2 -->
        <div style="flex: 1 1 180px; max-width: 250px;">
          <label for="codigo_documento">Documento (NIE,NIF) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigo_documento" id="codigo_documento" placeholder="Documento (NIE,NIF)"
                type="text">
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 3 -->
        <div style="flex: 2 1 350px; max-width: 550px;">
          <label for="razon_social">Razón Social </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="razon_social" id="razon_social" placeholder="Razón Social" type="text">
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 4 -->
        <div style="flex: 1 1 180px; max-width: 250px;">
          <label for="nima">NIMA </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="nima" id="nima" placeholder="Nima" type="text">
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 5 -->
        <div style="flex: 1 1 280px; max-width: 300px;">
          <label for="comunidad_autonoma">Comunidad Autónoma</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="comunidad_autonoma" id="comunidad_autonoma" placeholder="-- Comunidad --" [compareWith]="compareComunidad">
                <mat-option *ngFor="let comunidad of comunidadArray" [value]="comunidad">
                  {{ comunidad.nombre }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('comunidad_autonoma')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'comunidad_autonoma')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        
        <!-- Campo 6 -->
        <div style="flex: 1 1 250px;">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --" multiple [compareWith]="compareEstado">
                <mat-option *ngFor="let des of estadosArray" [value]="des">
                  {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 7 -->
        <div style="flex: 1 1 450px; max-width: 480px;">
          <label for="cnae">CNAE Principal</label>
          <div class="custom-mat-field">
            <lib-ge-select-pagination [endPointFilter]="cnaeEndpoint" [multiple]=true [updateList]="updateList"
              [descripcion]="getCnaDescription" [formControlNameSelect]="getFormControl('cnae')"
              [objQueryName]="getCnaeObjectQuery" [placeHolder]="'--CNAE Principal --'"
              [customClass]="rightHolder('cnae')">
            </lib-ge-select-pagination>
          </div>
        </div>
        <!-- Campo 8 -->
        <div style="flex: 1 1 210px; max-width: 260px;">
          <label for="contratoGestor">Tipo de registro</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="contratoGestor" id="contratoGestor" placeholder="Seleccionar">
                <mat-option [value]="true">Poseedor Final</mat-option>
                <mat-option [value]="false">Usuario SDDR Abierto</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 9 -->
        <div style="flex: 1 1 180px; max-width: 200px;">
          <label for="acuerdoGestorEnvalora">Acuerdo Gestor Envalora</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="acuerdoGestorEnvalora" id="acuerdoGestorEnvalora" placeholder="Seleccionar">
                <mat-option [value]="true">Sí</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
               <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
<mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
        <form class="container-fluid form-search py-3">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>
    <!-- FIN Formulario de búsqueda -->
  </div>
  <div class="bg-second-table-info pt-3 pb-5">
    <div *ngIf="flagSearch; else messageClear" class="container">
      <div class="actions-table">
        <div class=""><span class="align-middle tit-table">{{ recordsTotal }} registros encontrados</span></div>
        <div class="botones-tabla">
          <div class="d-inline" *ngIf="this.canViewRol('AD-ENV-GEST')">
            <div class="dropdown show">
              <a class="btn btn-outline-primary" role="button" aria-haspopup="true" aria-expanded="false" style="margin-right:5px;"
                (click)="comprobarCambioEstado()">
                <span>Cambiar estado</span></a>
            </div>
          </div>
          <div class="d-inline">
            <div class="dropdown show">
              <a (click)="exportarExcel()" class="btn btn-outline-primary" role="button" aria-haspopup="true"
                aria-expanded="false">
                <span>Exportar</span></a>
            </div>
          </div>
        </div>
      </div>
      <div class="card-tabla-proy">
        <div class="card-body">
          <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
            <div class="datatable-container table-responsive">
              <!-- TABLA Listado con resultados de búsqueda -->
              <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (checked)="checked($event)"
                (actionButton)="action($event)"></lib-ge-table>
              <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
                <div class="d-flex mt-2">
                  <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                    (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                  </ngb-pagination>
                </div>

                <div class="mt-2 selectPage">
                  <label for="itemsPerPage">Mostrar:</label>
                  <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                    <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                  </select>
                </div>
              </div>
              <!-- FIN TABLA Listado con resultados de búsqueda -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #messageClear>
      <div class="mensaje-container">
        <p class="mensaje-linea">No hay resultados de búsqueda, por favor seleccione, al menos, un criterio en el
          formulario</p>
        <p class="mensaje-linea"></p>
      </div>
    </ng-template>
  </div>
